import { Outlet } from "react-router-dom";
import BottomNav from "@/components/BottomNav";
import { ShellNavContext } from "@/components/layouts/ShellNavContext";

/**
 * AppShell — layout persistente genérico com BottomNav fixa.
 *
 * A BottomNav é montada UMA única vez (fora do <Outlet />): não é recriada a
 * cada troca de tela, portanto não pisca, não some durante a rolagem e mantém
 * estado (badge de não lidas, sheets). O conteúdo rola dentro do próprio
 * documento enquanto a barra permanece `fixed bottom-0`, respeitando as
 * safe-areas do dispositivo.
 *
 * `reserveBottomSpace`: quando `true` (padrão), o shell reserva a altura da
 * barra + safe-area. Telas que já aplicam seu próprio padding inferior
 * (ex.: `pb-24`) devem passar `false` para evitar espaço duplicado.
 */
export default function AppShell({
  reserveBottomSpace = true,
}: {
  reserveBottomSpace?: boolean;
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <ShellNavContext.Provider value={true}>
        <div
          className={
            "flex-1 min-h-0" +
            (reserveBottomSpace
              ? " pb-[calc(5.25rem+env(safe-area-inset-bottom,0px))]"
              : " pb-[env(safe-area-inset-bottom,0px)]")
          }
        >
          <Outlet />
        </div>
      </ShellNavContext.Provider>
      <BottomNav />
    </div>
  );
}
